import { render, staticRenderFns } from "./myFoodOrderDetail.vue?vue&type=template&id=49a6798f&scoped=true"
import script from "./myFoodOrderDetail.vue?vue&type=script&lang=js"
export * from "./myFoodOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./myFoodOrderDetail.vue?vue&type=style&index=0&id=49a6798f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6798f",
  null
  
)

export default component.exports